// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"121":"93c47839d09dbfc0","539":"70e742f5cdccc60c"}[chunkId] + ".js";
};